<template>
  <div class="InputLabel-fieldLabel">
    <div>
      <div class="labelWithTooltip">
        <div class="innerLabel" v-html="label"></div>
        <b-tooltip
          v-if="tooltip && tooltip.length > 0 && !disabled"
          type="is-dark"
          :label="tooltip"
          size="is-large"
          multilined
          position="is-top"
        >
          <b-icon size="is-small" icon="question-circle"></b-icon>
        </b-tooltip>
      </div>
      <div v-if="inputNotice" class="inputNotice" v-html="inputNotice"></div>
    </div>
    <div
      v-if="
        (showValidationErrors ||
          (!disabled && validationActivated) ||
          (!isPorteurProjet && validationActivated)) &&
        label
      "
    >
      <div v-if="isMandatory" class="mandatory">{{ $t("obligatoire") }}</div>
      <div v-else class="mandatory">{{ $t("facultatif") }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { LoginService } from "@/services/rest/login/LoginService"
import { UsersService } from "@/services/rest/users/UsersService"
import { BIcon, BTooltip } from "buefy"

export default defineComponent({
  name: "FormInputLabel",
  components: { BIcon, BTooltip },
  props: {
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isMandatory: {
      type: Boolean,
      default: false,
    },
    validationActivated: {
      type: Boolean,
      default: true,
    },
    showValidationErrors: {
      type: Boolean,
      default: true,
    },
    inputNotice: {
      type: String,
      default: "",
    },
    tooltip: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isPorteurProjet: true,
    }
  },
  mounted(): void {
    this.isPorteurProjet = UsersService.INSTANCE.isPorteurProjet(
      LoginService.INSTANCE.getLoggedUser(),
    )
  },
})
</script>

<style lang="scss">
@import "@/styles/variables";

.InputLabel-fieldLabel {
  display: flex;
  justify-content: space-between;
  width: 100%;

  .labelWithTooltip {
    display: flex;
    gap: 0.5rem;
  }

  .mandatory {
    padding-left: 20px;
    color: $dark;
  }
}
.inputNotice {
  font-weight: normal;
  font-style: italic;
}
</style>
